import Tab from "./Tab";  
import Tabs from "./Tabs";  

export default Tabs;
export { Tab };
